var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.584 21.0833H17.4173C16.4048 21.0833 15.584 21.9041 15.584 22.9166V41.25C15.584 42.2625 16.4048 43.0833 17.4173 43.0833H26.584C27.5965 43.0833 28.4173 42.2625 28.4173 41.25V22.9166C28.4173 21.9041 27.5965 21.0833 26.584 21.0833Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 32.0833H2.74935C1.73683 32.0833 0.916016 32.9041 0.916016 33.9166V41.25C0.916016 42.2625 1.73683 43.0833 2.74935 43.0833H10.0827C11.0952 43.0833 11.916 42.2625 11.916 41.25V33.9166C11.916 32.9041 11.0952 32.0833 10.0827 32.0833Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2507 37.5833H33.9173C32.9048 37.5833 32.084 38.4041 32.084 39.4166V41.25C32.084 42.2625 32.9048 43.0833 33.9173 43.0833H41.2507C42.2632 43.0833 43.084 42.2625 43.084 41.25V39.4166C43.084 38.4041 42.2632 37.5833 41.2507 37.5833Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7499 6.41668H28.2717C28.4654 6.41676 28.654 6.47819 28.8107 6.59215C28.9673 6.7061 29.0837 6.86673 29.1434 7.051C29.2031 7.23526 29.2028 7.43368 29.1427 7.6178C29.0826 7.80192 28.9657 7.96227 28.8089 8.07585L25.8755 10.2043L27.6832 14.3587C27.7581 14.534 27.7765 14.7283 27.7358 14.9146C27.6951 15.1008 27.5974 15.2698 27.4562 15.3978C27.315 15.5259 27.1373 15.6068 26.948 15.6292C26.7587 15.6516 26.5671 15.6144 26.3999 15.5228L21.9999 13.057L17.6164 15.5228C17.4492 15.6144 17.2576 15.6516 17.0682 15.6292C16.8789 15.6068 16.7013 15.5259 16.5601 15.3978C16.4188 15.2698 16.3211 15.1008 16.2804 14.9146C16.2397 14.7283 16.2581 14.534 16.333 14.3587L18.1407 10.2043L15.2074 8.07585C15.0513 7.96292 14.9348 7.80372 14.8744 7.62084C14.814 7.43795 14.8127 7.24068 14.8707 7.05703C14.9288 6.87338 15.0432 6.71267 15.1977 6.59772C15.3523 6.48278 15.5391 6.41943 15.7317 6.41668H19.2499L21.1455 1.50334C21.2122 1.33061 21.3295 1.1821 21.4822 1.07736C21.6348 0.972624 21.8156 0.916565 22.0008 0.916565C22.1859 0.916565 22.3667 0.972624 22.5194 1.07736C22.672 1.1821 22.7894 1.33061 22.856 1.50334L24.7499 6.41668Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 28.4166C8.44171 28.4166 10.0833 26.775 10.0833 24.75C10.0833 22.7249 8.44171 21.0833 6.41667 21.0833C4.39162 21.0833 2.75 22.7249 2.75 24.75C2.75 26.775 4.39162 28.4166 6.41667 28.4166Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5827 33.9166C39.6077 33.9166 41.2493 32.275 41.2493 30.25C41.2493 28.2249 39.6077 26.5833 37.5827 26.5833C35.5576 26.5833 33.916 28.2249 33.916 30.25C33.916 32.275 35.5576 33.9166 37.5827 33.9166Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertAchievement);
export default __webpack_public_path__ + "static/media/expert_achievement.89be1b718c9143d178ac282364007fcf.svg";
export { ForwardRef as ReactComponent };